import { playerPitchEventsAtom, playerUnwrappedPitchEventsAtom } from '@/atoms/player/vis';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventBuckets } from '@/components/visualisations/EventBuckets';
import { PitchVisComponentProps } from '@/types/visualisation';

export const PlayerEventBuckets = ({ allowInteraction }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <EventBuckets
      allowInteraction={allowInteraction}
      pitchEventsAtom={playerPitchEventsAtom}
      unwrappedPitchEventsAtom={playerUnwrappedPitchEventsAtom}
    />
  </MetricKeyFallbackWrapper>
);
